import type { FC, ReactNode } from 'react'

import { Link } from 'react-router-dom'

import { APP_ROUTES } from '@/util/appRoutes'

const PolicyLink: FC<{ id: number; isLocked: boolean; children?: ReactNode }> = ({
  id,
  children,
  isLocked,
}) => {
  if (!isLocked) {
    return <Link to={APP_ROUTES.ecomPolicy.replace(':ecomPolicyId', String(id))}>{children}</Link>
  }

  if (!children) return null

  return <>{children}</>
}

export default PolicyLink
